import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ModelPage from "./pages/ModelPage";
import LessonsIndex from "./pages/LessonsIndex";
import LessonDetail from "./pages/LessonDetail";
import Theory from "./pages/Theory";
import Preview from "./pages/Preview";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Assessment from "./pages/Assessment";
import Results from "./pages/Results";
import Legal from "./pages/Legal";
import CookieNotice from "./components/CookieNotice";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import PageViewTracker from "./components/PageViewTracker";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { initMetaPixel } from "./lib/metaPixel";

function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <PageViewTracker />
        <AnalyticsTracker />
        <SiteHeader />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/model" element={<ModelPage />} />
            <Route path="/lessons" element={<LessonsIndex />} />
            <Route path="/lessons/:slug" element={<LessonDetail />} />
            <Route path="/theory" element={<Theory />} />
            <Route path="/preview" element={<Preview />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/assessment/:purchaseId" element={<Assessment />} />
            <Route path="/results/:purchaseId" element={<Results />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/refund" element={<Legal doc="refund" />} />
          </Routes>
        </main>
        <SiteFooter />
        <CookieNotice />
        <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, border: "1px solid #1A1915", background: "#FAFAF9", color: "#1A1915" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
